import { enderecoStep, DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL } from '../../shared/enderecoSections';
import { termosStep } from '../../shared/termosSections';
import { mergeDadosRequerimentoConfig } from '../../../core/services/dadosRequerimentoConfigUtils';

const pedidoLicenciamentoConfig = {
  id: 'pedido_licenciamento',
  nome: 'Pedido de Licenciamento',
  categoria: 'inscricao',
  descricao: 'Solicitação de licenciamento na OAB/MS',
  icon: 'FaFileAlt',

  documentConfig: {
    required: [
      { 
        id: 'requerimento', tipoDocumentoProcesso: 433, 
        name: 'Requerimento', 
        description: 'Requerimento de Licenciamento preenchido e assinado digitalmente', 
        required: true 
      }
    ],

    optional: [
      { 
        id: 'termoDePosse', tipoDocumentoProcesso: 378, 
        name: 'Termo de Posse', 
        description: 'Documento de posse em cargo público ou função pública, caso o licenciamento seja por motivo de exercício de cargo ou função pública.',
        required: false 
      }
    ],

    conditional: []
  },

  paymentConfig: {
    amount: 152.00
  },

  protocoloConfig: {
    modeloRequerimento: '273',
    tiposAssunto: '769',
    tipoPedido: '469'
  },

  dadosRequerimentoConfig: mergeDadosRequerimentoConfig(
    {
      campos: [
        { field: 'nomeCompleto', campoNome: 'Nome' },
        { field: 'cpf', campoNome: 'CPFCNPJ' }
      ]
    },
    DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL
  ),

  tituloConfig: {
    tipoLancamentoId: 77,
    enderecoOrigem: 'residencial'
  },

  steps: [
    {
      id: 'dados_pessoais',
      title: 'Dados Pessoais',
      sections: [
        {
          title: 'Identificação do Requerente',
          fields: [
            { 
              type: 'text', 
              name: 'nomeCompleto', 
              label: 'Nome completo', 
              required: true, 
              placeholder: 'Digite seu nome completo' 
            },
            { 
              type: 'cpf', 
              name: 'cpf', 
              label: 'CPF', 
              required: true 
            }
          ]
        }
      ]
    },
    enderecoStep({ autoCep: true }),
    termosStep()
  ]
};

export default pedidoLicenciamentoConfig;